// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   OmniSearch — Standalone Styles
   ============================================================ */

/* ── Container ───────────────────────────────────────────── */
.os-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  padding: 24px 28px 0;
  box-sizing: border-box;
  overflow: hidden;
}

/* ── Hero Search Bar ─────────────────────────────────────── */
.os-hero {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
}

.os-hero-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-primary, #111);
  margin: 0 0 6px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.os-hero-title i {
  color: #6366f1;
}

.os-hero-subtitle {
  font-size: 0.82rem;
  color: var(--text-secondary, #6b7280);
  margin: 0 0 18px;
}

.os-search-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 700px;
}

.os-search-input {
  flex: 1 1;
  height: 46px;
  padding: 0 18px;
  border: 2px solid var(--border-color, #e5e7eb);
  border-radius: 12px;
  font-size: 1rem;
  background: var(--bg-secondary, #fff);
  color: var(--text-primary, #111);
  outline: none;
  transition: border-color 0.18s;
}

.os-search-input:focus {
  border-color: #6366f1;
}

.os-search-btn {
  height: 46px;
  padding: 0 22px;
  border: none;
  border-radius: 12px;
  background: #6366f1;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.18s, transform 0.1s;
  white-space: nowrap;
}

.os-search-btn:hover:not(:disabled) {
  background: #4f46e5;
}

.os-search-btn:active:not(:disabled) {
  transform: scale(0.97);
}

.os-search-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* depth/limit controls */
.os-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.os-control-label {
  font-size: 0.78rem;
  color: var(--text-secondary, #6b7280);
  display: flex;
  align-items: center;
  gap: 6px;
}

.os-control-label select {
  padding: 3px 8px;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  background: var(--bg-secondary, #fff);
  color: var(--text-primary, #111);
  font-size: 0.78rem;
  cursor: pointer;
}

/* ── Stats Bar ───────────────────────────────────────────── */
.os-stats-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0 10px;
  flex-wrap: wrap;
}

.os-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.74rem;
  font-weight: 600;
  border: 1px solid transparent;
}

.os-stat-chip.listing   { background: rgba(16,185,129,.1); color: #059669; border-color: rgba(16,185,129,.25); }
.os-stat-chip.knowledge { background: rgba(99,102,241,.1); color: #4f46e5; border-color: rgba(99,102,241,.25); }
.os-stat-chip.document  { background: rgba(245,158,11,.1); color: #b45309; border-color: rgba(245,158,11,.25); }
.os-stat-chip.market    { background: rgba(239,68,68,.1);  color: #b91c1c; border-color: rgba(239,68,68,.25); }
.os-stat-chip.edge      { background: rgba(107,114,128,.1); color: #374151; border-color: rgba(107,114,128,.25); }

.os-stat-chip i { font-size: 0.7rem; }

/* ── Main Area ───────────────────────────────────────────── */
.os-main {
  flex: 1 1;
  display: flex;
  min-height: 0;
  gap: 16px;
  padding-bottom: 16px;
}

/* ── Graph Canvas ────────────────────────────────────────── */
.os-graph-wrap {
  flex: 1 1;
  min-width: 0;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  background: var(--bg-secondary, #fafafa);
}

.os-graph-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  color: var(--text-secondary, #6b7280);
}

.os-graph-empty i {
  font-size: 3rem;
  opacity: 0.35;
}

.os-graph-empty h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary, #111);
}

.os-graph-empty p {
  margin: 0;
  font-size: 0.82rem;
}

.os-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(var(--bg-secondary-rgb, 255,255,255), 0.75);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 20;
  gap: 12px;
  color: var(--text-secondary, #6b7280);
  font-size: 0.88rem;
}

.os-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border-color, #e5e7eb);
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: os-spin 0.7s linear infinite;
}

@keyframes os-spin { to { transform: rotate(360deg); } }

.os-error {
  margin: 0;
  padding: 10px 14px;
  background: rgba(239,68,68,.08);
  border: 1px solid rgba(239,68,68,.25);
  border-radius: 10px;
  color: #b91c1c;
  font-size: 0.82rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Node Legend ─────────────────────────────────────────── */
.os-legend {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  background: var(--bg-primary, #fff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 10px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.os-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.72rem;
  color: var(--text-secondary, #6b7280);
}

.os-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Detail Sidebar ──────────────────────────────────────── */
.os-sidebar {
  width: 300px;
  flex-shrink: 0;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 14px;
  background: var(--bg-secondary, #fff);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.os-sidebar-header {
  padding: 14px 16px 10px;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.os-sidebar-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary, #111);
  margin: 0;
  line-height: 1.3;
}

.os-sidebar-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 700;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.os-sidebar-close {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  font-size: 0.85rem;
  flex-shrink: 0;
  border-radius: 6px;
  transition: background 0.15s;
}

.os-sidebar-close:hover {
  background: var(--bg-tertiary, #f3f4f6);
}

.os-sidebar-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.os-detail-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.os-detail-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary, #6b7280);
}

.os-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.8rem;
}

.os-detail-key {
  color: var(--text-secondary, #6b7280);
  flex-shrink: 0;
}

.os-detail-val {
  color: var(--text-primary, #111);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.os-detail-link {
  color: #6366f1;
  text-decoration: none;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.os-detail-link:hover { text-decoration: underline; }

.os-detail-desc {
  font-size: 0.79rem;
  color: var(--text-secondary, #6b7280);
  line-height: 1.55;
  margin: 0;
}

/* edges list inside sidebar */
.os-conn-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.os-conn-row {
  background: var(--bg-tertiary, #f9fafb);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 0.77rem;
  color: var(--text-primary, #111);
}

.os-conn-label {
  color: var(--text-secondary, #6b7280);
  font-size: 0.7rem;
}

/* ── Custom ReactFlow Node ───────────────────────────────── */
.os-node {
  border-radius: 10px;
  padding: 10px 14px;
  min-width: 130px;
  max-width: 190px;
  box-shadow: 0 3px 10px rgba(0,0,0,.12);
  cursor: pointer;
  transition: box-shadow 0.18s;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.os-node:hover {
  box-shadow: 0 6px 18px rgba(0,0,0,.2);
}

.os-node.selected {
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 0 0 3px rgba(99,102,241,0.5), 0 6px 18px rgba(0,0,0,.2);
}

.os-node-icon {
  font-size: 1rem;
  margin-bottom: 4px;
  opacity: 0.9;
}

.os-node-label {
  font-size: 0.74rem;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
  word-break: break-word;
}

.os-node-sub {
  font-size: 0.65rem;
  opacity: 0.8;
  color: #fff;
  margin-top: 3px;
  line-height: 1.3;
}

.os-node-type-tag {
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 0.55rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.7;
  color: #fff;
}

/* ── Dark Theme Overrides ────────────────────────────────── */
[data-theme="dark"] .os-search-input {
  background: var(--bg-tertiary, #1f2937);
  border-color: var(--border-color, #374151);
  color: var(--text-primary, #f9fafb);
}

[data-theme="dark"] .os-control-label select {
  background: var(--bg-tertiary, #1f2937);
  border-color: var(--border-color, #374151);
  color: var(--text-primary, #f9fafb);
}

[data-theme="dark"] .os-graph-wrap {
  background: var(--bg-tertiary, #111827);
}

[data-theme="dark"] .os-sidebar {
  background: var(--bg-secondary, #1f2937);
}

[data-theme="dark"] .os-legend {
  background: var(--bg-secondary, #1f2937);
}

[data-theme="dark"] .os-loading-overlay {
  background: rgba(17,24,39, 0.75);
}

[data-theme="dark"] .os-conn-row {
  background: var(--bg-primary, #111827);
}

[data-theme="dark"] .os-stat-chip.edge {
  background: rgba(156,163,175,.12);
  color: #d1d5db;
  border-color: rgba(156,163,175,.25);
}

/* ── Sidebar action buttons ──────────────────────────────── */
.os-pin-btn {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: none;
  border-radius: 8px;
  background: rgba(99,102,241,.1);
  color: #4f46e5;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.16s, color 0.16s;
}

.os-pin-btn:hover {
  background: rgba(99,102,241,.18);
  color: #3730a3;
}

.os-view-btn {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.16s, transform 0.1s;
}

.os-view-btn:active {
  transform: scale(0.97);
}

/* Entity → indigo */
.os-view-btn--entity {
  background: rgba(99,102,241,.12);
  color: #4f46e5;
}
.os-view-btn--entity:hover {
  background: rgba(99,102,241,.22);
}

/* Community → amber */
.os-view-btn--community {
  background: rgba(245,158,11,.12);
  color: #b45309;
}
.os-view-btn--community:hover {
  background: rgba(245,158,11,.22);
}

/* Document → orange */
.os-view-btn--document {
  background: rgba(217,119,6,.12);
  color: #92400e;
}
.os-view-btn--document:hover {
  background: rgba(217,119,6,.22);
}

/* ── Detail overlays (Community + Document) ──────────────── */
.os-detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  backdrop-filter: blur(2px);
}

.os-detail-overlay-inner {
  width: min(90vw, 1100px);
  height: 100%;
  background: var(--bg-primary, #f4f4f5);
  overflow-y: auto;
  box-shadow: -4px 0 32px rgba(0,0,0,.18);
  animation: os-slide-in 0.22s ease;
  display: flex;
  flex-direction: column;
}

@keyframes os-slide-in {
  from { transform: translateX(40px); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

[data-theme="dark"] .os-detail-overlay-inner {
  background: var(--bg-primary, #111827);
}

[data-theme="dark"] .os-pin-btn {
  background: rgba(99,102,241,.15);
  color: #818cf8;
}
[data-theme="dark"] .os-pin-btn:hover {
  background: rgba(99,102,241,.25);
}

[data-theme="dark"] .os-view-btn--entity {
  background: rgba(99,102,241,.15);
  color: #818cf8;
}
[data-theme="dark"] .os-view-btn--entity:hover {
  background: rgba(99,102,241,.28);
}

[data-theme="dark"] .os-view-btn--community {
  background: rgba(245,158,11,.15);
  color: #fbbf24;
}
[data-theme="dark"] .os-view-btn--community:hover {
  background: rgba(245,158,11,.28);
}

[data-theme="dark"] .os-view-btn--document {
  background: rgba(217,119,6,.15);
  color: #f59e0b;
}
[data-theme="dark"] .os-view-btn--document:hover {
  background: rgba(217,119,6,.28);
}
`, "",{"version":3,"sources":["webpack://./src/styles/OmniSearch.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,gCAAgC;EAChC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0BAA0B,+BAA+B,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAC/G,0BAA0B,+BAA+B,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAC/G,0BAA0B,+BAA+B,EAAE,cAAc,EAAE,kCAAkC,EAAE;AAC/G,0BAA0B,8BAA8B,GAAG,cAAc,EAAE,iCAAiC,EAAE;AAC9G,0BAA0B,gCAAgC,EAAE,cAAc,EAAE,mCAAmC,EAAE;;AAEjH,kBAAkB,iBAAiB,EAAE;;AAErC,+DAA+D;AAC/D;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,SAAO;EACP,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,8CAA8C;EAC9C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,cAAc;EACd,8CAA8C;EAC9C,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wBAAwB,0BAA0B,EAAE;;AAEpD;EACE,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,mCAAmC;AACrC;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,uCAAuC;EACvC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC","sourcesContent":["/* ============================================================\n   OmniSearch — Standalone Styles\n   ============================================================ */\n\n/* ── Container ───────────────────────────────────────────── */\n.os-page {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 120px);\n  padding: 24px 28px 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* ── Hero Search Bar ─────────────────────────────────────── */\n.os-hero {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 20px;\n}\n\n.os-hero-title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--text-primary, #111);\n  margin: 0 0 6px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.os-hero-title i {\n  color: #6366f1;\n}\n\n.os-hero-subtitle {\n  font-size: 0.82rem;\n  color: var(--text-secondary, #6b7280);\n  margin: 0 0 18px;\n}\n\n.os-search-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  max-width: 700px;\n}\n\n.os-search-input {\n  flex: 1;\n  height: 46px;\n  padding: 0 18px;\n  border: 2px solid var(--border-color, #e5e7eb);\n  border-radius: 12px;\n  font-size: 1rem;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary, #111);\n  outline: none;\n  transition: border-color 0.18s;\n}\n\n.os-search-input:focus {\n  border-color: #6366f1;\n}\n\n.os-search-btn {\n  height: 46px;\n  padding: 0 22px;\n  border: none;\n  border-radius: 12px;\n  background: #6366f1;\n  color: #fff;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.18s, transform 0.1s;\n  white-space: nowrap;\n}\n\n.os-search-btn:hover:not(:disabled) {\n  background: #4f46e5;\n}\n\n.os-search-btn:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.os-search-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* depth/limit controls */\n.os-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.os-control-label {\n  font-size: 0.78rem;\n  color: var(--text-secondary, #6b7280);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.os-control-label select {\n  padding: 3px 8px;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 6px;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary, #111);\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n/* ── Stats Bar ───────────────────────────────────────────── */\n.os-stats-bar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0 10px;\n  flex-wrap: wrap;\n}\n\n.os-stat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n.os-stat-chip.listing   { background: rgba(16,185,129,.1); color: #059669; border-color: rgba(16,185,129,.25); }\n.os-stat-chip.knowledge { background: rgba(99,102,241,.1); color: #4f46e5; border-color: rgba(99,102,241,.25); }\n.os-stat-chip.document  { background: rgba(245,158,11,.1); color: #b45309; border-color: rgba(245,158,11,.25); }\n.os-stat-chip.market    { background: rgba(239,68,68,.1);  color: #b91c1c; border-color: rgba(239,68,68,.25); }\n.os-stat-chip.edge      { background: rgba(107,114,128,.1); color: #374151; border-color: rgba(107,114,128,.25); }\n\n.os-stat-chip i { font-size: 0.7rem; }\n\n/* ── Main Area ───────────────────────────────────────────── */\n.os-main {\n  flex: 1;\n  display: flex;\n  min-height: 0;\n  gap: 16px;\n  padding-bottom: 16px;\n}\n\n/* ── Graph Canvas ────────────────────────────────────────── */\n.os-graph-wrap {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 14px;\n  overflow: hidden;\n  position: relative;\n  background: var(--bg-secondary, #fafafa);\n}\n\n.os-graph-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 12px;\n  color: var(--text-secondary, #6b7280);\n}\n\n.os-graph-empty i {\n  font-size: 3rem;\n  opacity: 0.35;\n}\n\n.os-graph-empty h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary, #111);\n}\n\n.os-graph-empty p {\n  margin: 0;\n  font-size: 0.82rem;\n}\n\n.os-loading-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(var(--bg-secondary-rgb, 255,255,255), 0.75);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 20;\n  gap: 12px;\n  color: var(--text-secondary, #6b7280);\n  font-size: 0.88rem;\n}\n\n.os-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border-color, #e5e7eb);\n  border-top-color: #6366f1;\n  border-radius: 50%;\n  animation: os-spin 0.7s linear infinite;\n}\n\n@keyframes os-spin { to { transform: rotate(360deg); } }\n\n.os-error {\n  margin: 0;\n  padding: 10px 14px;\n  background: rgba(239,68,68,.08);\n  border: 1px solid rgba(239,68,68,.25);\n  border-radius: 10px;\n  color: #b91c1c;\n  font-size: 0.82rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── Node Legend ─────────────────────────────────────────── */\n.os-legend {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  z-index: 10;\n  background: var(--bg-primary, #fff);\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 10px;\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.os-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.72rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.os-legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* ── Detail Sidebar ──────────────────────────────────────── */\n.os-sidebar {\n  width: 300px;\n  flex-shrink: 0;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 14px;\n  background: var(--bg-secondary, #fff);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.os-sidebar-header {\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid var(--border-color, #e5e7eb);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.os-sidebar-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary, #111);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.os-sidebar-type-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.os-sidebar-close {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: var(--text-secondary, #6b7280);\n  font-size: 0.85rem;\n  flex-shrink: 0;\n  border-radius: 6px;\n  transition: background 0.15s;\n}\n\n.os-sidebar-close:hover {\n  background: var(--bg-tertiary, #f3f4f6);\n}\n\n.os-sidebar-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.os-detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.os-detail-section-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary, #6b7280);\n}\n\n.os-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.8rem;\n}\n\n.os-detail-key {\n  color: var(--text-secondary, #6b7280);\n  flex-shrink: 0;\n}\n\n.os-detail-val {\n  color: var(--text-primary, #111);\n  font-weight: 500;\n  text-align: right;\n  word-break: break-word;\n}\n\n.os-detail-link {\n  color: #6366f1;\n  text-decoration: none;\n  font-size: 0.8rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.os-detail-link:hover { text-decoration: underline; }\n\n.os-detail-desc {\n  font-size: 0.79rem;\n  color: var(--text-secondary, #6b7280);\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* edges list inside sidebar */\n.os-conn-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.os-conn-row {\n  background: var(--bg-tertiary, #f9fafb);\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 0.77rem;\n  color: var(--text-primary, #111);\n}\n\n.os-conn-label {\n  color: var(--text-secondary, #6b7280);\n  font-size: 0.7rem;\n}\n\n/* ── Custom ReactFlow Node ───────────────────────────────── */\n.os-node {\n  border-radius: 10px;\n  padding: 10px 14px;\n  min-width: 130px;\n  max-width: 190px;\n  box-shadow: 0 3px 10px rgba(0,0,0,.12);\n  cursor: pointer;\n  transition: box-shadow 0.18s;\n  border: 2px solid transparent;\n  position: relative;\n  overflow: hidden;\n}\n\n.os-node:hover {\n  box-shadow: 0 6px 18px rgba(0,0,0,.2);\n}\n\n.os-node.selected {\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 0 0 3px rgba(99,102,241,0.5), 0 6px 18px rgba(0,0,0,.2);\n}\n\n.os-node-icon {\n  font-size: 1rem;\n  margin-bottom: 4px;\n  opacity: 0.9;\n}\n\n.os-node-label {\n  font-size: 0.74rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #fff;\n  word-break: break-word;\n}\n\n.os-node-sub {\n  font-size: 0.65rem;\n  opacity: 0.8;\n  color: #fff;\n  margin-top: 3px;\n  line-height: 1.3;\n}\n\n.os-node-type-tag {\n  position: absolute;\n  top: 5px;\n  right: 6px;\n  font-size: 0.55rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  opacity: 0.7;\n  color: #fff;\n}\n\n/* ── Dark Theme Overrides ────────────────────────────────── */\n[data-theme=\"dark\"] .os-search-input {\n  background: var(--bg-tertiary, #1f2937);\n  border-color: var(--border-color, #374151);\n  color: var(--text-primary, #f9fafb);\n}\n\n[data-theme=\"dark\"] .os-control-label select {\n  background: var(--bg-tertiary, #1f2937);\n  border-color: var(--border-color, #374151);\n  color: var(--text-primary, #f9fafb);\n}\n\n[data-theme=\"dark\"] .os-graph-wrap {\n  background: var(--bg-tertiary, #111827);\n}\n\n[data-theme=\"dark\"] .os-sidebar {\n  background: var(--bg-secondary, #1f2937);\n}\n\n[data-theme=\"dark\"] .os-legend {\n  background: var(--bg-secondary, #1f2937);\n}\n\n[data-theme=\"dark\"] .os-loading-overlay {\n  background: rgba(17,24,39, 0.75);\n}\n\n[data-theme=\"dark\"] .os-conn-row {\n  background: var(--bg-primary, #111827);\n}\n\n[data-theme=\"dark\"] .os-stat-chip.edge {\n  background: rgba(156,163,175,.12);\n  color: #d1d5db;\n  border-color: rgba(156,163,175,.25);\n}\n\n/* ── Sidebar action buttons ──────────────────────────────── */\n.os-pin-btn {\n  width: 100%;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(99,102,241,.1);\n  color: #4f46e5;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.16s, color 0.16s;\n}\n\n.os-pin-btn:hover {\n  background: rgba(99,102,241,.18);\n  color: #3730a3;\n}\n\n.os-view-btn {\n  width: 100%;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.16s, transform 0.1s;\n}\n\n.os-view-btn:active {\n  transform: scale(0.97);\n}\n\n/* Entity → indigo */\n.os-view-btn--entity {\n  background: rgba(99,102,241,.12);\n  color: #4f46e5;\n}\n.os-view-btn--entity:hover {\n  background: rgba(99,102,241,.22);\n}\n\n/* Community → amber */\n.os-view-btn--community {\n  background: rgba(245,158,11,.12);\n  color: #b45309;\n}\n.os-view-btn--community:hover {\n  background: rgba(245,158,11,.22);\n}\n\n/* Document → orange */\n.os-view-btn--document {\n  background: rgba(217,119,6,.12);\n  color: #92400e;\n}\n.os-view-btn--document:hover {\n  background: rgba(217,119,6,.22);\n}\n\n/* ── Detail overlays (Community + Document) ──────────────── */\n.os-detail-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  backdrop-filter: blur(2px);\n}\n\n.os-detail-overlay-inner {\n  width: min(90vw, 1100px);\n  height: 100%;\n  background: var(--bg-primary, #f4f4f5);\n  overflow-y: auto;\n  box-shadow: -4px 0 32px rgba(0,0,0,.18);\n  animation: os-slide-in 0.22s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes os-slide-in {\n  from { transform: translateX(40px); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n[data-theme=\"dark\"] .os-detail-overlay-inner {\n  background: var(--bg-primary, #111827);\n}\n\n[data-theme=\"dark\"] .os-pin-btn {\n  background: rgba(99,102,241,.15);\n  color: #818cf8;\n}\n[data-theme=\"dark\"] .os-pin-btn:hover {\n  background: rgba(99,102,241,.25);\n}\n\n[data-theme=\"dark\"] .os-view-btn--entity {\n  background: rgba(99,102,241,.15);\n  color: #818cf8;\n}\n[data-theme=\"dark\"] .os-view-btn--entity:hover {\n  background: rgba(99,102,241,.28);\n}\n\n[data-theme=\"dark\"] .os-view-btn--community {\n  background: rgba(245,158,11,.15);\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .os-view-btn--community:hover {\n  background: rgba(245,158,11,.28);\n}\n\n[data-theme=\"dark\"] .os-view-btn--document {\n  background: rgba(217,119,6,.15);\n  color: #f59e0b;\n}\n[data-theme=\"dark\"] .os-view-btn--document:hover {\n  background: rgba(217,119,6,.28);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
